import { jsx as m, jsxs as A } from "react/jsx-runtime";
import { forwardRef as I, useId as C, useRef as E, useCallback as p } from "react";
import { c as h } from "./cn-DlLpp5ix.js";
import { F as R } from "./focus-BJKdC9pu.js";
const L = {
  sm: "h-7 text-2xs",
  md: "h-8 text-xs"
}, O = {
  sm: "px-2.5",
  md: "px-3"
};
function _(g, x) {
  const {
    value: v,
    onValueChange: o,
    options: s,
    size: u = "md",
    className: w,
    "aria-label": D,
    name: S,
    disabled: f = !1
  } = g, k = C(), y = S ?? `segmented-${k}`, b = E([]), c = p((t) => {
    const n = b.current[t];
    n && !n.disabled && n.focus();
  }, []), N = p(
    (t, n) => {
      if (f) return;
      const i = (e, a) => {
        let d = e, r = 0;
        for (; r < s.length; ) {
          if (d = (d + a + s.length) % s.length, !s[d]?.disabled) return d;
          r += 1;
        }
        return e;
      }, l = (e) => {
        const a = e === 1 ? 0 : s.length - 1, d = e === 1 ? s.length : -1;
        for (let r = a; r !== d; r += e)
          if (!s[r]?.disabled) return r;
        return -1;
      };
      switch (t.key) {
        case "ArrowRight":
        case "ArrowDown": {
          t.preventDefault();
          const e = i(n, 1);
          c(e);
          const a = s[e];
          a && o(a.value);
          break;
        }
        case "ArrowLeft":
        case "ArrowUp": {
          t.preventDefault();
          const e = i(n, -1);
          c(e);
          const a = s[e];
          a && o(a.value);
          break;
        }
        case "Home": {
          t.preventDefault();
          const e = l(1);
          if (e >= 0) {
            c(e);
            const a = s[e];
            a && o(a.value);
          }
          break;
        }
        case "End": {
          t.preventDefault();
          const e = l(-1);
          if (e >= 0) {
            c(e);
            const a = s[e];
            a && o(a.value);
          }
          break;
        }
      }
    },
    [f, c, o, s]
  );
  return /* @__PURE__ */ m(
    "div",
    {
      ref: x,
      role: "radiogroup",
      "aria-label": D,
      "aria-disabled": f || void 0,
      "data-size": u,
      className: h(
        "inline-flex items-stretch gap-0.5 p-0.5 rounded-lg bg-bg-elevated border border-default",
        w
      ),
      children: s.map((t, n) => {
        const i = t.value === v, l = f || t.disabled;
        return /* @__PURE__ */ A(
          "button",
          {
            ref: (e) => {
              b.current[n] = e;
            },
            type: "button",
            role: "radio",
            "aria-checked": i,
            "aria-disabled": l || void 0,
            disabled: l,
            "data-state": i ? "on" : "off",
            "data-name": y,
            tabIndex: i ? 0 : -1,
            onClick: () => {
              l || o(t.value);
            },
            onKeyDown: (e) => N(e, n),
            className: h(
              "inline-flex items-center gap-1.5 select-none whitespace-nowrap rounded-md",
              "font-medium text-secondary transition-colors duration-fast ease-out",
              L[u],
              O[u],
              "data-[state=on]:bg-bg-surface data-[state=on]:text-primary data-[state=on]:shadow-xs",
              "hover:text-primary",
              "disabled:cursor-not-allowed disabled:text-tertiary disabled:hover:text-tertiary",
              R
            ),
            children: [
              t.icon !== void 0 && /* @__PURE__ */ m("span", { className: "inline-flex items-center", "aria-hidden": "true", children: t.icon }),
              /* @__PURE__ */ m("span", { children: t.label })
            ]
          },
          t.value
        );
      })
    }
  );
}
const K = I(_);
export {
  K as S
};
//# sourceMappingURL=Segmented-BLqj2LnF.js.map
